import { Heading, Table } from '@msaf/core-react'
import { FeatureAction } from '../../../../components/pdf/types'
import { getCollectionAggregateForProperty, getPlantingPreparationMaintenanceSummary } from '../utils'
import { toDollarCurrencyFormat } from '../../../utils'
import { PdfReadOnlyField } from '../../../../components/pdf/read-only-field'
import { ApplicationDetailsFields } from '../../../../routes/plans/[mode]/[id]/application/[applicationId]/details/config'

interface PlantingSummaryBaseTypeProps {
  features: FeatureAction[]
  applicationDetailsData: ApplicationDetailsFields | undefined
}

export const PlantingPreparationMaintenanceSummary = ({
  features,
  applicationDetailsData,
}: PlantingSummaryBaseTypeProps) => {
  const tablePages = 1
  const aggregates = getPlantingPreparationMaintenanceSummary(applicationDetailsData, features)

  const estimatedFreightCost = Number(applicationDetailsData?.estimatedFreightCost) || 0
  const totalAdditionalCost = Number(applicationDetailsData?.totalAdditionalCost) || 0
  const totalCost =
    getCollectionAggregateForProperty(features, 'proposedCost') + estimatedFreightCost + totalAdditionalCost

  // Format aggregates for presentation
  const data = aggregates.map((feature) => ({
    ...feature,
    estimatedCost: toDollarCurrencyFormat(feature.estimatedCost),
  }))

  return (
    <section className='l-section--no-break-inside l-pdf-container--margin-small'>
      <Heading level={3} className='c-field__heading--margin-small'>
        Native planting and any preparation, maintenance, project costings
      </Heading>
      <Table
        tableData={data}
        showResultsCount={false}
        totalResults={data.length}
        totalPages={tablePages}
        setPage={() => tablePages}
        currentPage={tablePages}
        setSortColumn={() => 'locationName'}
        defaultSortBy={{
          orderColumn: 'locationName',
          orderDirection: 'desc',
        }}
        columnHeaders={[
          {
            elementKey: 'action',
            columnHeading: 'Actions',
            viewColumn: 'action',
            sortable: false,
            type: 'text',
          },
          {
            elementKey: 'quantity',
            columnHeading: 'Quantity',
            viewColumn: 'quantity',
            sortable: false,
            type: 'text',
          },
          {
            elementKey: 'estimatedCost',
            columnHeading: 'Estimated Total Cost ($)',
            viewColumn: 'estimatedCost',
            sortable: false,
            type: 'text',
          },
        ]}
      />
      <PdfReadOnlyField
        fieldName='Sub-total native planting, preparation, maintenance and project admin costings'
        value={toDollarCurrencyFormat(totalCost)}
      />
    </section>
  )
}
